import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const token = localStorage.getItem('prona_userToken') ? localStorage.getItem('prona_userToken') : null

export const notificationTemplatesApi = createApi({
    reducerPath: 'notificationTemplatesApi',
    baseQuery: (fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin/blogs`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    endpoints: (build) => ({
        getTemplates: build.query({
            query() {
                return {
                    url: '/blogs/getAllBlogs',
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Blogs']
        }),
        getTemplateById: build.query({
            query(id) {
                return {
                    url: `/blogs/getBlogById/${id}`,
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Blog']
        }),
        deleteTemplate: build.mutation({
            query(id) {
                return {
                    url: `/blogs/deleteBlog/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['Blogs']
        }),
        updateTemplate: build.mutation({
            query: ({ data, id }) => ({
                url: `/blogs/updateBlog/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Blogs', 'Blog']
        }),
    })
});

export const { useGetTemplatesQuery, useGetTemplateByIdQuery, useDeleteTemplateMutation, useUpdateTemplateMutation } = notificationTemplatesApi;